<template>
    <div></div>
  </template>
  
  <script>
  
  export default {
    mounted() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      // 判断是否为Android设备
      if (/android/i.test(userAgent)) {
        window.location.href = 'https://file.huishouka.com.cn/apk/huishouka_guanwang.apk';
      }
  
      // 判断是否为iOS设备
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = 'https://itunes.apple.com/cn/app/id6743080450';
      }
    },
  
  }
  </script>
  
  